const AchievementType =  {
    Primary : 1,
    Secondary : 2,
    IsSkiped:0
};

export default AchievementType;